import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import jwtDecode from 'jwt-decode';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
    user: {},
  },
  mutations: {
    auth_request(state) {
      state.status = 'loading';
    },
    auth_success(state, token, user) {
      state.status = 'success';
      state.token = token;
      state.user = user;
    },
    auth_error(state) {
      state.status = 'error';
    },
    logout(state) {
      state.status = '';
      state.token = '';
    },
  },
  actions: {
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request');
        let url = '';
        if (window.location.hostname === 'localhost') {
          url = 'http://localhost:8081/login';
        } else {
          url = 'https://smart-stewards.herokuapp.com/login';
        }
        axios({
          url,
          data: user,
          method: 'POST',
        })
          .then((res) => {
            const {
              token,
              riskAppetite,
              bank,
              checkSubscription,
            } = res.data;
            const decoded = jwtDecode(token);
            localStorage.setItem('userSubscription', checkSubscription);
            localStorage.setItem('token', token);
            localStorage.setItem('bank', JSON.stringify(bank));
            localStorage.setItem('user', JSON.stringify(decoded));
            localStorage.setItem('risk_appetite', riskAppetite);
            axios.defaults.headers.common.Authorization = `Bearer ${token}`;
            commit('auth_success', token, user);
            resolve(res);
          })
          .catch((err) => {
            commit('auth_error');
            localStorage.removeItem('token');
            reject(err);
          });
      });
    },

    register({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request');
        let url = '';
        if (window.location.hostname === 'localhost') {
          url = 'http://localhost:8081/register';
        } else {
          url = 'https://smart-stewards.herokuapp.com/register';
        }
        axios({ url, data: user, method: 'POST' })
          .then((res) => {
            const { token } = res.data;
            const decoded = jwtDecode(token);
            localStorage.setItem('token', token);
            localStorage.setItem('user', JSON.stringify(decoded));
            axios.defaults.headers.common.Authorization = `Bearer ${token}`;
            commit('auth_success', token, user);
            resolve(res);
          })
          .catch((err) => {
            commit('auth_error', err);
            localStorage.removeItem('token');
            reject(err.response);
          });
      });
    },

    logout({ commit }) {
      return new Promise((resolve) => {
        commit('logout');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        delete axios.defaults.headers.common.Authorization;
        resolve();
      });
    },
  },
  getters: {
    isLoggedIn: (state) => !!state.token,
    authStatus: (state) => state.status,
  },
  modules: {
  },
});
